// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1GXqK","inputDescription":"styles_inputDescription__2U7gB"};